import React from 'react';
import { Box, Typography } from '@mui/material';
import ContentFeed from '../components/ContentFeed';
import { useAuth } from '../context/AuthContext';
import '../styles/ProtectedRoutes.css';

const HomePage = () => {
    const { loading } = useAuth();

    if (loading) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }} className="glass-content-container">
                <Typography variant="h6" className="glass-title">
                    Loading...
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            <ContentFeed />
        </Box>
    );
};

export default HomePage;